var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(this.$store.state.logedIn)?_c('Main'):_c('Login'),_c('Footer'),(_vm.msgExist)?_c('InfoBlock'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }